import { render, staticRenderFns } from "./SlyderD.vue?vue&type=template&id=ab4562fa&scoped=true&lang=pug&"
import script from "./SlyderD.vue?vue&type=script&lang=js&"
export * from "./SlyderD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4562fa",
  null
  
)

export default component.exports